module.exports = __webpack_public_path__ + "static/media/menu.c165fe87.png";